export default {"src":"/_next/static/media/UI-white.a32d3400.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};